import { useContext, useEffect, useRef } from "react";
import { MakeClassName } from "../../component/global/MakeClassName";
import { GlobalStateContext } from "../GlobalStates";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import {
    APP_TABBAR_MAX_WIDTH,
    getAppFlavorFromPath,
} from "../../helperData/appFlavor";

const RightSidebarTab = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { currentPanel, setCurrentPanel } = useContext(GlobalStateContext);

    useEffect(() => {
        const isMobile = window.matchMedia(
            `(max-width: ${APP_TABBAR_MAX_WIDTH}px)`
        ).matches;
        if (isMobile) return;
        const fromPath = getAppFlavorFromPath(location.pathname);
        if (fromPath) {
            setCurrentPanel(fromPath);
        }
    }, [location.pathname, setCurrentPanel]);

    const handleTab = (tab) => {
        setCurrentPanel(tab);
    };

    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) {
            return;
        }
        didMount.current = true;
    }, [currentPanel]);

    return (
        <div className="sidebar_tab">
            <div
                className={MakeClassName(
                    `tab_item  user`,
                    (currentPanel === "user" || !currentPanel) && " active"
                )}
                onClick={() => handleTab("user")}
            >
                {t("User.Portal.label")}
            </div>
            {(window.sessionStorage.getItem("usertype") == 1 ||
                window.sessionStorage.getItem("usertype") == 2) && (
                <div
                    className={MakeClassName(
                        `tab_item  organ`,
                        currentPanel === "organ" && " active"
                    )}
                    onClick={() => handleTab("organ")}
                >
                    {t("Corpration.Panel.label")}
                </div>
            )}
        </div>
    );
};

export default RightSidebarTab;
